import { render, staticRenderFns } from "./_DoTypeAlong.vue?vue&type=template&id=37afc1ba"
import script from "./_DoTypeAlong.vue?vue&type=script&lang=js"
export * from "./_DoTypeAlong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports